<button
  mat-flat-button
  [ngClass]="{
    'consultant-card-team-toggle-button-add': !isInTeamCached,
    'consultant-card-team-toggle-button-remove': isInTeamCached
  }"
  (click)="toggleTeamMembership()"
>
  {{ buttonTextCached }}
</button>
